import React from 'react';
import * as ReactDataGrid from 'react-data-grid';
import {
    ProspectsGridContainerProps,
    useProspectsSortState,
    getGridProspectInfoDisplay,
    ProspectsColumns,
    ViewActivityType
} from './recentActivity';
import { ProspectsGridColumns } from '../../../../utilities/Enums';
import * as identity from '../../../../utilities/identity';
import { prospectsComparer } from '../ProspectsSubPage';

export const ProspectsGridContainer = ({ prospects, typeCall }: ProspectsGridContainerProps) => {
    const [sortColumn, sortDirection, setSort] = useProspectsSortState(
        'DESC',
        ProspectsGridColumns.InitialDate
    );

    let sortedProspects = prospects.sort(
        sortDirection === 'NONE'
            ? prospectsComparer(ProspectsGridColumns.InitialDate, 'ASC')
            : prospectsComparer(sortColumn, sortDirection)
    );

    let mappedProspects = sortedProspects.map((prospect, index) => ({
        ...getGridProspectInfoDisplay(prospect),
        prospect: prospect
    }));

    // Custom Formatter for the 3-dot menu
    const MenuFormatter = ({ prospect }: { prospect: any }) => (
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', alignItems: 'center' }}>
            {/* Block Icon */}
           { 
           identity.userIsCompanyDashboardAdmin() && (
           !prospect.blockedStatus ?
           <button
                style={{
                    border: '1px solid red',
                    backgroundColor: 'transparent',
                    cursor: 'pointer',
                    color: 'red',
                    fontSize: '12px',
                    padding: '2px 16px',
                    borderRadius: '4px',
                    outline: 'none'
                }}
                onClick={() => {
                    typeCall(ViewActivityType.BlockView, prospect.prospectUserId.toString());
                }}
            >
                Block
            </button> :
            <button
                    style={{
                        border: '1px solid grey',
                        backgroundColor: 'transparent',
                        cursor: 'pointer',
                        color: 'grey',
                        fontSize: '12px',
                        padding: '2px 10px',
                        borderRadius: '4px',
                        outline: 'none'
                    }}
                    onClick={() => {
                    
                    }}
                >
              Blocked
          </button>)
        }
        </div>
    );
    

    return (
        <ReactDataGrid
            columns={[
                ProspectsColumns.Name,
                {
                    ...ProspectsColumns.Email,
                    width: 270, // Increase the width of the Email column (adjust value as needed)
                },
                ProspectsColumns.Phone,
                ProspectsColumns.InitialDate,
                ProspectsColumns.LastTourDate,
                ProspectsColumns.LastTourPropertyName,
                ProspectsColumns.Status,
                ProspectsColumns.ApplicationStatus,
                { key: 'prospect', name: '', formatter: (props) => {
                    return (
                        <MenuFormatter
                          prospect={props.value}
                        />
                    );
                }}
            ]}
            rowGetter={i => mappedProspects[i]}
            rowsCount={prospects.length}
            onGridSort={setSort}
            onRowClick={(_rowIdx: number, row: any) => {
                if (row && row.prospectUserId) {
                    typeCall(ViewActivityType.ProspectView, row.prospectUserId.toString());
                }
            }}
        />
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/admin/dashboardWidgets/prospectsGridContainer.tsx